<template>
    <div class="otp-container">
        <div class="otp-input" v-for="(digit, index) in otpDigits" :key="index">
        <input 
            v-model="otp[index]"
            :ref="'otp' + index"
            maxlength="1"
            @keydown="onKeydown($event, index)"
            @input="onInput($event, index)"
            @focus="selectText($event)"
            class="input "
            type="text"
        />
        </div>
  </div>
</template>


<script>
export default {
  name : "OTPInput",
  mounted(){
    this.$refs['otp0'][0].focus();
     
  } ,
  data() {
    return {
      otp: Array(6).fill('')
    };
  },
  computed: {
    otpDigits() {
      return this.otp.length;
    }
  },
  methods: {
    handleSubmit() {
      // Handle the submission logic here
      console.log('OTP submitted:', this.otp.join(''));
      this.$emit('submitOTP',this.otp.join(''))
    },
    onKeydown(event, index) {
      if (event.key === 'Enter' && index === this.otpDigits - 1) {
        this.handleSubmit();
      } else if (event.key === 'Backspace' && !this.otp[index] && index > 0) {
        this.$refs['otp' + (index - 1)][0].focus();
      } else if (event.key === 'ArrowLeft' && index > 0) {
        this.$refs['otp' + (index - 1)][0].focus();
      } else if (event.key === 'ArrowRight' && index < this.otpDigits - 1) {
        this.$refs['otp' + (index + 1)][0].focus();
      }
    },
    onInput(event, index) {
      const value = event.target.value;
      if (/^[0-9]$/.test(value)) {
        this.otp[index] = value;
        if (index < this.otpDigits - 1) {
          this.$nextTick(() => {
            this.$refs['otp' + (index + 1)][0].focus();
          });
        }
      } else {
        this.otp[index] = '';
      }


      this.$emit('changeOTP',this.otp)
    },
    selectText(event) {
       event.target.select();
    }
  }
};


</script>



<style scoped>
.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  margin: 0 0.5rem;
}

input {
  width: 5rem;
  text-align: center;
  font-size: 1.5rem;
  border: 2px solid #ddd;
  border-radius: 50px;
  transition: border-color 0.3s;
  color: #270f09 !important;  
  background-color: #fff !important; 
  font-weight: bold !important; 
}

input:focus {
  outline: none;
  border-color: #3273dc;
}
</style>